import { get } from "../../utils/httpService";

const SERVICE_URLS = {
  getAllProducts: () => `/client/getAllProducts`,
};

export const getAllProducts = (body, params) => {
  return get(SERVICE_URLS.getAllProducts(), body, params);
};
